export const pagesEN = {
  notFound: {
    title: '404: Page not found...',
    subtitle: 'There has been an error while trying to display this page',
    link: 'Back to Homepage',
  },
};
